import React from "react";
import './contact-info.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MaskedTextField from "../../components/MaskedTextField";
import { Box, InputAdornment, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";



class ContactInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          PhoneNumber: props.data.PhoneNumber,
          PhoneExtension: props.data.PhoneExtension,
          FaxNumber: props.data.FaxNumber,
          WebsiteUrl: props.data.WebsiteUrl,
        };
    }
    async handlePhoneNumber(e) {
        await this.setState({ PhoneNumber: e });
        let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
        if (e == "") {
            this.props.setPhoneNumberError("Please enter phone number");
        } else if (!regphone.test(e)) {
            this.props.setPhoneNumberError("Format like (000) 000-0000");
        } else {
            this.props.setPhoneNumberError("");
        }
    }
    async handlePhoneNumberExtension(e) {
        // await this.setState({ PhoneExtension: e });

        const inputValue = e;
        const numericInput = inputValue.replace(
          /[^0-9]/g,
          ""
        );        
        if (numericInput.length <= 10) {
          if (numericInput === "") {       
            this.props.setPhoneExtensionError("");
          } 
          else if (numericInput) {
            this.props.setPhoneExtensionError("");
          } else {
            this.props.setPhoneExtensionError("Use only number format");
          }
        } else {
          // Limit to 10 digits, no further input allowed
          // setPhone(numericInput.slice(0, 10));
          this.props.setPhoneExtensionError("");
        }
        await this.setState({ PhoneExtension: numericInput });
      }
    async handleFaxNumber(e) {
        await this.setState({ FaxNumber: e });
        let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
        if (e == "") {
          this.props.setFaxNumberError("");
        } else if (!regphone.test(e)) {
          this.props.setFaxNumberError("Format like (000) 000-0000");
        } else {
          this.props.setFaxNumberError("");
        }
    }
    async handleWebsiteUrl(e) {
        await this.setState({ WebsiteUrl: e });
    }
    render() {


        return (
          <>
            <div className="first-verify__registerationContainer">
              <div className="first-verify__inputContainer">
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6>Use the primary phone number of your business. If there is a different number for yourself, enter it below in the Primary user section.</h6>
                  </div>
                }
                arrow
              >
                <div className="formControl-container">
                  <span className="username-label">
                    {this.props.languageContent.contactInfo.phoneNumber}
                    <span className="asterisk-red">*</span>
                  </span>
                  {/* <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      height: 50,
                    }}
                    id="outlined-basic"
                    error={this.props.phoneNumberErrorFlag}
                    placeholder={
                      this.props.languageContent.contactInfo.phoneNumber
                    }
                    defaultValue={this.props.data.PhoneNumber}
                    onChange={(e) => this.handlePhoneNumber(e.target.value)}
                    inputProps={{ className: "login-user" }}
                    variant="outlined"
                  />
                        */}
           
                  <MaskedTextField
                    mask="(999) 999-9999"
                    placeholder="(555) 000-0000"
                    value={this.state.PhoneNumber || ""}
                    onChange={(e) => this.handlePhoneNumber(e)}
                    size="small"
                    inputProps={{ className: "login-user" }}
                    className="input-number-cstm-style"
                  />
                 
                  <Typography className="text-danger mt-1" component={"span"}>
                    {this.props.phoneNumberErrorFlag}
                  </Typography>
                </div>
                </Tooltip>
                <div className="formControl-container">
                  <span className="username-label">
                    {
                      this.props.languageContent.contactInfo
                        .phoneNumberExtension
                    }

                    {/* <span className="asterisk-red">*</span> */}
                  </span>
                  <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      height: 50,
                    }}
                    id="outlined-basic"
                    //
                    error={this.props.phoneExtensionErrorFlag}
                    placeholder={
                      this.props.languageContent.contactInfo
                        .phoneNumberExtension
                    }
                    defaultValue={this.props.data.PhoneExtension}
                    onChange={(e) =>
                      this.handlePhoneNumberExtension(e.target.value)
                    }
                    value={this.state.PhoneExtension || ""}
                    inputProps={{ className: "login-user" }}
                    variant="outlined"
                  />
                  <Typography className="text-danger mt-1" component={"span"}>
                    {this.props.phoneExtensionErrorFlag}
                  </Typography>
                </div>
                <div className="formControl-container">
                  <span className="username-label">
                    {this.props.languageContent.contactInfo.faxNumber}
                    {/* 
                    <span className="asterisk-red">*</span> */}
                  </span>
                  {/* <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      height: 50,
                    }}
                    id="outlined-basic"
                    // error={this.props.faxNumberErrorFlag}

                    placeholder={
                      this.props.languageContent.contactInfo.faxNumber
                    }
                    defaultValue={this.props.data.FaxNumber}
                    onChange={(e) => this.handleFaxNumber(e.target.value)}
                    inputProps={{ className: "login-user" }}
                    variant="outlined"
                  /> */}

                  <MaskedTextField
                    mask="(999) 999-9999"
                    value={this.state.FaxNumber || ""}
                    onChange={(e) => this.handleFaxNumber(e)}
                    size="small"
                    inputProps={{ className: "login-user" }}
                    className="input-number-cstm-style"
                  />
                  <Typography className="text-danger mt-1" component={"span"}>
                    {this.props.faxNumberErrorFlag}
                  </Typography>
                </div>
                <div className="formControl-container">
                  <span className="username-label">
                    {this.props.languageContent.contactInfo.websiteUrl}
                    {/* 
                    <span className="asterisk-red">*</span> */}
                  </span>
                  <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6>Enter the URL of your website, if any. <br /> <h3>Example:</h3>www.smithindustries.com</h6>
                  </div>
                }
                arrow
              >
                  <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      height: 50,
                    }}
                    id="outlined-basic"
                    error={this.props.WebsiteUrlErrorFlag}
                    placeholder={
                      this.props.languageContent.contactInfo.websiteUrl
                    }
                    defaultValue={this.props.data.WebsiteUrl}
                    onChange={(e) => this.handleWebsiteUrl(e.target.value)}
                    inputProps={{ className: "login-user" }}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box>http:// </Box>
                        </InputAdornment>
                      ),
                    }}
                    className="input-websiteURL-cstm-style"
                  />
                  </Tooltip>
                </div>
                <div className="formControl-container">
                  <Button
                    variant="outlined"
                    sx={{ marginTop: 1, textTransform: "capitalize" }}
                    className="login-button-cancel-address"
                    onClick={() =>
                      this.props.data.setContactInformationForm(
                        this.state.PhoneNumber.trim(),
                        this.state.PhoneExtension.trim(),
                        this.state.FaxNumber.trim(),
                        this.state.WebsiteUrl.trim(),
                        "back"
                      )
                    }
                  >
                    {this.props.languageContent.contactInfo.back}
                  </Button>
                  <Button
                    variant="contained"
                    className="login-button-address"
                    sx={{ textTransform: "capitalize" }}
                    onClick={() =>
                      this.props.data.setContactInformationForm(
                        this.state.PhoneNumber.trim(),
                        this.state.PhoneExtension.trim(),
                        this.state.FaxNumber.trim(),
                        this.state.WebsiteUrl.trim(),
                        "next"
                      )
                    }
                  >
                    {this.props.languageContent.contactInfo.next}
                  </Button>
                </div>
              </div>
            </div>
          </>
        );
    }
}

export default ContactInfo;